const TwitterFeed = () => {
  return (
    <a 
      href="https://x.com/Bienestar_Hgo" 
      target="_blank" 
      rel="noopener noreferrer"
      style={{ textDecoration: 'none', display: 'block' }}
    >
      <div style={{ 
        backgroundColor: '#6b0f1a',
        borderRadius: '12px',
        color: '#fff',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '24px',
        padding: '24px 32px',
        boxSizing: 'border-box',
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s'
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'scale(1.01)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(107, 15, 26, 0.3)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = 'none';
      }}
      >
        {/* Izquierda: Icono + Texto */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="#fff">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
          
          <div style={{ textAlign: 'left' }}>
            <h3 style={{ margin: '0 0 4px 0', fontSize: '1.3rem', color: '#fff', fontWeight: '500' }}>@Bienestar_Hgo</h3>
            <p style={{ color: '#d4a5a5', margin: 0, fontSize: '0.9rem', lineHeight: '1.3' }}>
              Sigue las últimas noticias y actividades de la Secretaría de Bienestar e Inclusión Social.
            </p>
          </div>
        </div>

        {/* Derecha: Botón */}
        <span style={{
          display: 'inline-block',
          backgroundColor: '#fff',
          color: '#6b0f1a',
          padding: '10px 24px',
          borderRadius: '9999px',
          fontWeight: 'bold',
          fontSize: '0.9rem',
          whiteSpace: 'nowrap',
          flexShrink: 0
        }}>
          Seguir en X
        </span>
      </div>
    </a>
  );
};

export default TwitterFeed;